import React, { useEffect, useState } from 'react';

import ReusableButton from '../../../../../../../reusables/Button';
import ReusableCard from '../../../../../../../reusables/Card';
import ReusableSelect from '../../../../../../../reusables/Select';

import ReusableInfo from '../../../../../../../reusables/Info';
import DialogExchangeOptions from '../dialogs/DialogExchangeOptions';
import ModalConfirmation from '../../../../../components/Modal/Modal';
import ContentModalTwoButtons from '../../../../../components/ContentModalTwoButtons';
import TextHelper from '../../../../../../../../core/helpers/TextHelper';

interface IProps {
  currentData?: any;
  isProcessingProgramByCampus: boolean;
  isVirtual: boolean;
  isVirtualChange: boolean;
  programByCampus: any[];
  getProgramByCampus: (_id: string) => void;
  onChanges: (_value: any) => void;
  onNotChanges: () => void;
  setIsVirtualChange: (value: boolean) => void;
  isPPE: boolean;
}

const ExchangeOptions = ({
  currentData,
  isProcessingProgramByCampus,
  isVirtual,
  isVirtualChange,
  programByCampus,
  getProgramByCampus,
  onChanges,
  onNotChanges,
  setIsVirtualChange,
  isPPE
}: IProps) => {
  const [dialogChanges, setDialogChanges] = useState<boolean>(false);
  const [dialogNotChanges, setDialogNotChanges] = useState<boolean>(false);

  const [isValid, setIsValid] = useState<boolean>(false);

  const [paramsToSend, setParamsToSend] = useState<any>({});

  const [listCampus, setListCampus] = useState<any[]>([]);
  const [listPrograms, setListPrograms] = useState<any[]>([]);
  const [listModalities, setListModalities] = useState<any[]>([]);

  const [campusId, setCampusId] = useState<string>('');
  const [programId, setProgramId] = useState<string>('');
  const [modalityId, setModalityId] = useState<string>('');

  const [dataCampus, setDataCampus] = useState<any>();
  const [dataProgram, setDataProgram] = useState<any>();
  const [dataModality, setDataModality] = useState<any>();

  const campusListAll = [
    { id: 'LIMA', name: 'Lima Centro' },
    { id: 'CHICL', name: 'Chiclayo' },
    { id: 'AREQU', name: 'Arequipa' },
    { id: 'LIMAN', name: 'Lima Norte' },
    { id: 'LISJL', name: 'Lima San Juan de Lurigancho' },
    { id: 'LIATE', name: 'Lima Ate' },
    { id: 'LIMAS', name: 'Lima Sur' },
    { id: 'CHIMB', name: 'Chimbote' },
    { id: 'HUANC', name: 'Huancayo' },
    { id: 'ICA', name: 'Ica' },
    { id: 'PIURA', name: 'Piura' },
    { id: 'TRUJI', name: 'Trujillo' },
    { id: 'VIRT', name: 'Campus UTP' }
  ];

  const onSelectCampus = (_id: string) => {
    setCampusId(_id);
    getProgramByCampus(_id);
    setDataCampus(campusListAll?.find((c: any) => c.id === _id));
  };

  const onSelectProgram = (_id: string) => {
    programByCampus.forEach((v) => {
      if (v.id === _id) {
        setListModalities(v.modalities);
      }
    });

    setProgramId(_id);
    setDataProgram(listPrograms?.find((p: any) => p.id === _id));
  };

  const onSelectModality = (_id: string) => {
    if (!isVirtualChange && _id !== 'VIRT') {
      setCampusId('');
      setIsVirtualChange(true);
    }

    if (_id === 'VIRT') {
      setCampusId('');
      setIsVirtualChange(true);
      setDataCampus(campusListAll.find((c: any) => c.id === _id));
    }
    setModalityId(_id);
    setDataModality(listModalities?.find((p: any) => p.id === _id));
  };

  const handlerButton = () => {
    const prevData = {
      campus: currentData.currentAcademicData.campus.id,
      modality: currentData.currentAcademicData.studiesOption.modalityCode,
      program: currentData.currentAcademicData.program.id
    };

    const selectedModality = listModalities.find((a) => a.id === modalityId);
    const dataModalitySelect = listModalities?.find(
      (p: any) => p.id === modalityId
    );
    const currData = {
      campus: dataCampus.id,
      modality: modalityId,
      program: selectedModality?.codProgCM
    };
    const newModalityId =
      prevData.modality === currData.modality ? '' : dataModalitySelect?.id;
    const newModalityDescription =
      prevData.modality === currData.modality ? '' : dataModalitySelect?.id;
    const newCampusId =
      prevData.campus === currData.campus ? '' : dataCampus?.id;
    const newCampusDescription =
      prevData.campus === currData.campus ? '' : dataCampus?.name;

    const newCareerId = selectedModality?.codProgram;
    const newCareerDescription = dataProgram?.name;
    const newPlan = selectedModality?.codPlan;
    const hasNewCareer =
      currentData.currentAcademicData.grouping.id !== programId;
    const hasNewCampus = prevData.campus !== currData.campus;

    const requiresPayment =
      hasNewCareer ||
      (hasNewCampus &&
        prevData.campus !== 'VIRT' &&
        currData.campus !== 'VIRT');
    const reincorporationType = selectedModality?.reincorporationType;
    const newAcadCareer = selectedModality.acadCareer;
    const { codProgCM, codPlanCM, acadCareerCM } = selectedModality;
    setParamsToSend({
      newCampusDescription,
      newCampusId,
      newCareerDescription,
      newCareerId,
      newModalityDescription,
      newModalityId,
      requiresPayment,
      reincorporationType,
      newPlan,
      newAcadCareer,
      codProgCM,
      codPlanCM,
      acadCareerCM
    });
    const isDataChanged = JSON.stringify(prevData) !== JSON.stringify(currData);
    setDialogNotChanges(!isDataChanged);
    setDialogChanges(isDataChanged);
  };

  const handlerOnChanges = () => {
    setDialogChanges(false);

    if (paramsToSend.newModalityId === 'VIRT') {
      paramsToSend.newCampusDescription = 'Campus UTP';
      paramsToSend.newCampusId = 'VIRT';
    }
    onChanges(paramsToSend);
  };

  // useEffect(() => {
  //   const updateData = (list: any[], id: any, setData: any, setId?: any) => {
  //     if (list && id && list.length > 0 && id.length > 0) {
  //       const match = list?.find((v) => v.id === id);
  //       if (match) {
  //         setData(match);
  //       } else {
  //         setData(undefined);
  //         setId('');
  //       }
  //     }
  //   };

  //   updateData(campusListAll, campusId, setDataCampus, setCampusId);
  //   updateData(listPrograms, programId, setDataProgram, setProgramId);
  //   updateData(listModalities, modalityId, setDataModality, setModalityId);
  // }, [
  //   listCampus,
  //   listPrograms,
  //   listModalities,
  //   campusId,
  //   programId,
  //   modalityId
  // ]);

  useEffect(() => {
    const validCampus = modalityId === 'VIRT' ? true : campusId.length > 0; // && modalityId !== 'VIRT' && campusId !== 'VIRT'; // || isVirtual || campusId === '';
    const validProgram = programId.length > 0;
    const validModality = modalityId.length > 0;

    setIsValid(
      validCampus &&
        validProgram &&
        validModality &&
        !isProcessingProgramByCampus
    );
  }, [campusId, programId, modalityId, isProcessingProgramByCampus]);

  useEffect(() => {
    if (currentData) {
      const campusList = [
        { id: 'LIMA', name: 'Lima Centro' },
        { id: 'CHICL', name: 'Chiclayo' },
        { id: 'AREQU', name: 'Arequipa' },
        { id: 'LIMAN', name: 'Lima Norte' },
        { id: 'LISJL', name: 'Lima San Juan de Lurigancho' },
        { id: 'LIATE', name: 'Lima Ate' },
        { id: 'LIMAS', name: 'Lima Sur' },
        { id: 'CHIMB', name: 'Chimbote' },
        { id: 'HUANC', name: 'Huancayo' },
        { id: 'ICA', name: 'Ica' },
        { id: 'PIURA', name: 'Piura' },
        { id: 'TRUJI', name: 'Trujillo' }
      ];
      setListCampus(campusList);

      const { campus, grouping } = currentData.currentAcademicData;
      const { modalityCode: modality } =
        currentData.currentAcademicData.studiesOption;

      onSelectCampus(campus.id);
      setProgramId(grouping.id);
      setModalityId(modality);
    }
  }, [currentData]);

  useEffect(() => {
    if (programByCampus) {
      const programs: any[] = [];
      programByCampus.forEach((a) => {
        programs.push({ id: a.id, name: a.name });
        if (a.id === programId) {
          setListModalities(a.modalities);
          setDataProgram({ id: a.id, name: a.name });
          if (!a.modalities?.find((m: any) => m.id === modalityId)) {
            setIsValid(false);
          }
        }
      });
      if (!programByCampus.find((a) => a.id === programId)) {
        setModalityId('');
        setIsValid(false);
      }
      setListPrograms(programs);
    }
  }, [programByCampus]);

  return (
    <>
      <ReusableCard
        padding="24px 24px 24px 24px"
        style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}
      >
        <p style={{ color: '#1a055d' }}>
          {isVirtual ? (
            <>
              Actualmente estás en la modalidad{' '}
              <b style={{ textTransform: 'uppercase' }}>
                {currentData?.currentAcademicData?.studiesOption?.modalityName}
              </b>{' '}
              en la carrera de{' '}
              <b style={{ textTransform: 'uppercase' }}>
                {currentData?.currentAcademicData?.program?.name}
              </b>
            </>
          ) : (
            <>
              Actualmente estás en el campus{' '}
              <b style={{ textTransform: 'uppercase' }}>
                {currentData?.currentAcademicData?.campus?.name}
              </b>{' '}
              en la carrera de{' '}
              <b style={{ textTransform: 'uppercase' }}>
                {currentData?.currentAcademicData?.program?.name}
              </b>{' '}
              en la modalidad{' '}
              <b style={{ textTransform: 'uppercase' }}>
                {isPPE
                  ? 'SEMIPRESENCIAL'
                  : currentData?.currentAcademicData?.studiesOption
                      ?.modalityName}
              </b>
            </>
          )}
        </p>
        {(!isVirtual || isVirtualChange) && modalityId !== 'VIRT' && (
          <ReusableSelect
            itemCount={4}
            itemName="name"
            items={listCampus}
            itemValue="id"
            label="Cambio de campus:"
            onChange={(v) => onSelectCampus(v)}
            placeholder="Seleccionar"
            value={campusId}
          />
        )}
        <ReusableSelect
          isLoading={isProcessingProgramByCampus}
          itemCount={4}
          itemName="name"
          items={listPrograms?.map((p: any) => ({
            ...p,
            name: TextHelper.capitalize(p.name, false, true)
          }))}
          itemValue="id"
          label="Cambio de carrera:"
          onChange={(v) => onSelectProgram(v)}
          placeholder="Seleccionar"
          value={programId}
        />
        <ReusableSelect
          isLoading={isProcessingProgramByCampus}
          itemCount={4}
          itemName="name"
          items={listModalities}
          itemValue="id"
          label="Cambio de modalidad:"
          onChange={(v) => onSelectModality(v)}
          placeholder="Seleccionar"
          value={modalityId}
        />
        {/* <ReusableInfo text="Si cambias de campus y/o carrera, el cargo de tu monto será de S/175.00 sea por un cambio o por ambos. " /> */}
        <ReusableInfo text="Si deseas reincorporarte con un Cambio de Carrera, completa tu solicitud por este formulario y después registra un ticket; elige el trámite &ldquo;Cambio de Carrera&rdquo; ingresando a través del siguiente <a href='/tramites/ticketera/registro'>link</a>." />
        <ReusableButton
          text="Solicitar"
          disabled={!isValid}
          onClick={() => handlerButton()}
        />
      </ReusableCard>

      <DialogExchangeOptions
        isVirtual={isVirtual}
        show={dialogChanges}
        currentData={{
          program: dataProgram,
          campus: dataCampus,
          modality: dataModality
        }}
        previusData={currentData.currentAcademicData}
        handlerClose={() => setDialogChanges(false)}
        handlerOnNext={() => handlerOnChanges()}
      />

      <ModalConfirmation
        show={dialogNotChanges}
        handleClose={() => setDialogNotChanges(false)}
      >
        <ContentModalTwoButtons
          align="center"
          img={null}
          onClickButton1={() => {
            setDialogNotChanges(false);
            onNotChanges();
          }}
          onClickButton2={() => setDialogNotChanges(false)}
          showInfo={false}
          subtitle="Tus datos se están manteniendo igual, no estás realizando ningún cambio. <br />
          ¿Deseas continuar?"
          textButton1="Sí, continuar"
          textButton2="Realizar cambios"
          title="No has realizado ningún cambio"
        />
      </ModalConfirmation>
    </>
  );
};

export default ExchangeOptions;
